// Import all past papers data statically
import papersDataCambridgeIgcse from '../constants/PastPapers/CambridgeIgcse';
import papersDataEdexcelIgcse from '../constants/PastPapers/EdexcelIgcse';
import papersDataEdexcelGcse from '../constants/PastPapers/EdexcelGcse';
import papersDataAqaGcse from '../constants/PastPapers/AqaGcse';
import papersDataCambridgeInternationalAlevel from '../constants/PastPapers/CambridgeInternationalAlevel';
import papersDataEdexcelAlevel from '../constants/PastPapers/EdexcelAlevel';
import papersDataEdexcelInternationalAlevel from '../constants/PastPapers/EdexcelInternationalAlevel';

const hasPastPapersForSubject = (
  curriculum: string,
  subject: string
): boolean => {
  try {
    // Early return if no curriculum or subject provided
    if (!curriculum || !subject) {
      return false;
    }

    // Get past papers data based on curriculum
    let papersData: any = {};

    switch (curriculum.toLowerCase()) {
      case 'cambridge igcse':
        papersData = papersDataCambridgeIgcse;
        break;
      case 'edexcel igcse':
        papersData = papersDataEdexcelIgcse;
        break;
      case 'edexcel gcse':
        papersData = papersDataEdexcelGcse;
        break;
      case 'aqa gcse':
        papersData = papersDataAqaGcse;
        break;
      case 'cambridge international a levels':
        papersData = papersDataCambridgeInternationalAlevel;
        break;
      case 'edexcel a levels':
        papersData = papersDataEdexcelAlevel;
        break;
      case 'edexcel international a levels':
        papersData = papersDataEdexcelInternationalAlevel;
        break;
      default:
        return false;
    }

    // Convert subject name to match the key format in papers data
    const subjectKey = subject.toLowerCase().replace(/[-()]/g, '');

    // Check if the subject exists and has papers data
    return (
      papersData[subjectKey] &&
      Array.isArray(papersData[subjectKey]) &&
      papersData[subjectKey].length > 0
    );
  } catch (error) {
    console.warn('Error checking past papers availability:', error);
    return false;
  }
};

export default hasPastPapersForSubject;
